import React from "react";

function MenuSettings() {
  return (
    <div className="menuSettings">
      <h1>Unkai Radio Settings</h1>
      <p>This radio is a cloned version of radio.garden app</p>
    </div>
  );
}

export default MenuSettings;
